import React from 'react';

import { IEventGroupGame } from '../../../../../../store/player/events/store';

import { userPic } from '../../../../../../assets/images';

interface IProps {
  item: IEventGroupGame;
  context?: any;
  roundId: string;
}

export const Player = (props: IProps) => {
  const {
    item: {
      tee,
      handicap,
      enrollment: {
        user: {
          firstName,
          lastName,
          profile: { image: profileImage }
        },
        index,
        flight
      }
    },
    context: { useFlights }
  } = props;

  return (
    <div className="player-item">
      <img src={profileImage === null ? userPic : profileImage} alt={`${firstName}`} />

      <div className="main">
        <div className="top name">{`${firstName} ${lastName}`}</div>

        {useFlights && <div className="tee">{flight ? `${flight.name} Flight` : '--'}</div>}

        <div className="tee">{tee ? `${tee.name} Tee` : '--'}</div>
      </div>

      <div className="player-metadata">
        <div className="player-metadata-item">
          <span className="item-name">IND</span>

          <span className="item-value">{index ? index : '--'}</span>
        </div>

        <div className="player-metadata-item">
          <span className="item-name">HCP</span>

          <span className="item-value">{handicap}</span>
        </div>

        <div className="player-metadata-item">
          <span className="item-name">ADJ</span>

          <span className="item-value">--</span>
        </div>
      </div>
    </div>
  );
};
